import { createIcon } from '../icons/utils';

/**
 * Implant-date glyph: an outlined circle containing a pulse-generator "chip"
 * (a rounded square with contact pins on all four sides) and a lightning bolt.
 * Ported from the legacy Critical Summary progress bar's
 * `implant-date-circle.svg` so the marker reads the same to clinicians.
 *
 * Every stroke is `currentColor`, so the marker's own text colour drives the
 * glyph (`classNameBase` is cleared for the same reason).
 */
export const ImplantDateIcon = createIcon(
  ({ ref, className, innerClassName, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0.39 0.39 25.22 25.22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M13 25C19.624 25 25 19.624 25 13C25 6.376 19.624 1 13 1C6.376 1 1 6.376 1 13C1 19.624 6.376 25 13 25Z"
        stroke="currentColor"
        strokeWidth={1.21875}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className={innerClassName}
        d="M11.4001 18.3332H14.6001C17.2667 18.3332 18.3334 17.2665 18.3334 14.5998V11.3998C18.3334 8.73317 17.2667 7.6665 14.6001 7.6665H11.4001C8.73341 7.6665 7.66675 8.73317 7.66675 11.3998V14.5998C7.66675 17.2665 8.73341 18.3332 11.4001 18.3332Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className={innerClassName}
        d="M12.0001 16.3332H14.0001C15.6667 16.3332 16.3334 15.6665 16.3334 13.9998V11.9998C16.3334 10.3332 15.6667 9.6665 14.0001 9.6665H12.0001C10.3334 9.6665 9.66675 10.3332 9.66675 11.9998V13.9998C9.66675 15.6665 10.3334 16.3332 12.0001 16.3332Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Contact pins: three on each side of the chip. */}
      <path
        d="M10.3401 7.66683V6.3335"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 7.66683V6.3335"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6667 7.66683V6.3335"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 10.3335H19.6666"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 13H19.6666"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 15.6665H19.6666"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6667 18.3335V19.6668"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0066 18.3335V19.6668"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3401 18.3335V19.6668"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.33325 10.3335H7.66659"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.33325 13H7.66659"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.33325 15.6665H7.66659"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Lightning bolt inside the chip. */}
      <path
        className={innerClassName}
        d="M12.9999 11.4668L12.3732 12.5601C12.2332 12.8001 12.3466 13.0001 12.6266 13.0001H13.3732C13.6532 13.0001 13.7666 13.2001 13.6266 13.4401L12.9999 14.5335"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  { displayName: 'ImplantDateIcon', defaultSize: 20, classNameBase: '' },
);
